import { render, staticRenderFns } from "./BedMeshChart.vue?vue&type=template&id=47081a16&scoped=true&"
import script from "./BedMeshChart.vue?vue&type=script&lang=ts&"
export * from "./BedMeshChart.vue?vue&type=script&lang=ts&"
import style0 from "./BedMeshChart.vue?vue&type=style&index=0&id=47081a16&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "47081a16",
  null
  
)

export default component.exports